import { LoadingSpinner } from "components/LoadingSpinner";
import useDocumentTitle from "hooks/useDocumentTitle";
import { useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useGetPackageRulesetByIdQuery } from "store/queries/packageRuleset";

import { BundledCptCodes } from "./components/BundledCptCodes";
import { Header } from "./components/Header";
import { ProviderAndPayerCopySection } from "./components/ProviderAndPayerCopySection";
import { RuleName } from "./components/RuleName";
import { SubmitPackages } from "./components/SubmitPackages";
import { TriggerCptCodes } from "./components/TriggerCptCodes";

export function CopyPackagesPage() {
  useDocumentTitle("Copy Package Rules");
  const { id } = useParams();
  const { data: ruleset, isLoading } = useGetPackageRulesetByIdQuery(id);

  const methods = useForm({
    defaultValues: {
      provider: [
        {
          name: ruleset?.data.provider.name,
          value: ruleset?.data.provider.id,
        },
      ],
      payerName: [
        {
          name: ruleset?.data?.payer?.name,
          value: ruleset?.data?.payer?.id,
        },
      ],
      groupName: ruleset?.data.groupName,
      triggerCptCodes: ruleset?.data.triggerCptCodes,
      bundledCptCodes: ruleset?.data.bundledCptCodes,
    },
  });

  useEffect(() => {
    if (ruleset) {
      methods.reset({
        provider: [
          {
            name: ruleset?.data.provider.name,
            value: ruleset?.data.provider.id,
          },
        ],
        payerName: [
          {
            name: ruleset?.data?.payer?.name,
            value: ruleset?.data?.payer?.id,
          },
        ],
        groupName: ruleset?.data.groupName,
        triggerCptCodes: ruleset?.data.triggerCptCodes,
        bundledCptCodes: ruleset?.data.bundledCptCodes,
      });
    }
  }, [ruleset, methods]);

  if (isLoading) {
    return <LoadingSpinner />;
  }
  return (
    <FormProvider {...methods}>
      <Header name={ruleset?.data.groupName} isPackages />
      <ProviderAndPayerCopySection
        initialProviders={[
          {
            name: ruleset?.data.provider.name || "",
            value: ruleset?.data.provider.id || "",
          },
        ]}
        initialPayers={[
          {
            name: ruleset?.data?.payer?.name || "",
            value: ruleset?.data?.payer?.id || "",
          },
        ]}
      />
      <RuleName />
      <TriggerCptCodes />
      <BundledCptCodes />
      {id && ruleset && <SubmitPackages />}
    </FormProvider>
  );
}
